import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dhl': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M238 301.2l22.3-30.2h58.7l-22.3 30.2h-58.7zM0 282.9h86.5l-4.7 6.4h-81.8v-6.4zM172.9 271h68.2c-5.7 7.8-24.1 30.3-57.2 30.3h-100.1l41.1-55.8h51c5.6 0 5.6 2.2 2.8 5.9-2.8 3.7-7.6 10.3-10.4 14.1-1.4 1.9-4.1 5.5 4.6 5.5zM490.4 264.1h-62.2l39.3-53.4h62.2zM95.3 271l-4.7 6.4h-90.6v-6.4h95.3zM206.3 244.4c2.8-3.7 2.9-5.9-2.7-5.9h-111.4l20.4-27.8h117.9c29.9 0 37.6 23.6 29.2 35-6.2 8.4-13.5 18.4-13.5 18.4h-45.6c-8.7 0-6-3.5-4.6-5.5 2.8-3.8 7.5-10.4 10.3-14.2zM0 301.2v-6.4h77.8l-4.7 6.4h-73.1zM323 301.2c0 0 22.2-30.2 22.3-30.2h58.7l-22.3 30.2h-58.7zM545 301.3l4.7-6.4h90.3v6.4h-95zM567.3 271h72.7v6.4h-77.4zM553.8 289.3l4.7-6.4h81.5v6.4h-86.2zM389.6 210.7h58.7l-39.3 53.4h-143.6l39.3-53.4h58.7l-22.5 30.6h26.2zM423.1 271h133.4l-22.3 30.3h-94.3c-24.1 0-30.6-11.6-23.2-21.6 2.1-2.8 6.4-8.7 6.4-8.7z'
      }
    ]
  }
})
